import angular from 'angular'
import directive from './directive'
import StoryController from './controller'

export default angular
  .module('ellipsis.story', [])
  .directive('story', directive)
  .controller('StoryController', StoryController)
